import React, { Suspense } from "react";
//import { nanoid } from "nanoid";
import { ErrorBoundary } from "react-error-boundary";
//import "./App.css";
// import Info from "./info";
import LinearIndeterminate from "./loading.js";

import { BrowserRouter as Router1, Routes, Route } from "react-router-dom";

// import HomePage from "./HomePage";
import RealHomePage from "./RealHomePage";
//import NewPage from "./newPage";
// login may also not need lazy loading
//import Login from "./Login";
import ContactPage from "./ContactPage";
import About from "./About";
import CustomerChat from "./CustomerChat";
//import Logout from "./Logout";
import { FirebaseAuth } from "./context";
import PrivateRoutes from "./PrivateRoutes";

//import TransitionsModal from "./MaterialUIModal";
//import UsageInfo from "./UsageInfo.js";
//import { ReRoute } from "./ReRoute.js";
import Pricing from "./Pricing.js";
import CookieConsent from "./components/CookieConsent.js";
import MetaPixelTracker from "./components/MetaPixelTracker.js";

// lazy loading for improved loading performance and is used with suspense to allow loading/fallback content
//const SOCI = React.lazy(() => import("./soCI.jsx"));
const TermsAndConditions = React.lazy(() => import("./TermsAndConditions.js"));
//const FeedBack = React.lazy(() => import("./FeedBack.js"));
const Signup = React.lazy(() => import("./Signup.js"));
const Login = React.lazy(() => import("./Login.js"));
//const AfterLoginPage = React.lazy(() => import("./AfterLoginPage.js"));
const AddBusinesses = React.lazy(() => import("./AddBusinesses.js"));
const BusinessOnboarding = React.lazy(() => import("./BusinessOnboarding.js"));
const BusinessPage = React.lazy(() => import("./BusinessPage.js"));
const Directory = React.lazy(() => import("./Directory.js"));
const Deals = React.lazy(() => import("./Classifieds.js"));
const AdminDeals = React.lazy(() => import("./AdminClassifieds.js"));
const AdminBusinesses = React.lazy(() => import("./AdminBusinesses.js"));
const Businesses = React.lazy(() => import("./Businesses.js"));
const UserProfile = React.lazy(() => import("./UserProfile.js"));
const AddProduct = React.lazy(() => import("./AddProduct.js"));
const ProductsAdded = React.lazy(() => import("./ProductsAdded.js"));
const Analytics = React.lazy(() => import("./Analytics.js"));
const Internal = React.lazy(() => import("./Internal.js"));
const Messages = React.lazy(() => import("./Messages.js"));
const UsageInfo = React.lazy(() => import("./UsageInfo.js"));
const Guides = React.lazy(() => import("./blog.js"));
const GuidePost = React.lazy(() => import("./BlogPost.js"));
const GuideSubmission = React.lazy(() => import("./BlogSubmission.js"));
const GuideAnalytics = React.lazy(() => import("./BlogAnalytics.js"));
const GuideApproval = React.lazy(() => import("./BlogApproval.js"));
const Unsubscribe = React.lazy(() => import("./unsubscribe.js"));
const BuyersPortal = React.lazy(() => import("./BuyersPortal.js"));
const ServiceRequests = React.lazy(() => import("./ServiceRequests.js"));
const StatusPage = React.lazy(() => import("./StatusPage.js"));
const OrderTracking = React.lazy(() => import("./OrderTracking.js"));
const StoreOrders = React.lazy(() => import("./StoreOrders.js"));

//const About = React.lazy(() => import("./About"));
const Payments = React.lazy(() => import("./Payment.js"));
const BusinessMicrosite = React.lazy(() => import("./BusinessMicrosite.js"));

const ErrorFallback = React.lazy(() => import("./ErrorFallback.js"));

const PageNotFound = React.lazy(() => import("./pagenotfound.jsx"));
// const GiveUserAccess = React.lazy(() =>
//   import("./GiveUserAccess.js")
// );

function App() {
  return (
    <Router1>
      <MetaPixelTracker />
      <div className="App">
        <header className="App-header">
          {/* FirebaseAuth allows private to access functions */}
          <FirebaseAuth>
            {/* <ReRoute> */}
            {/* shown when the component is loaded, as it its not already loaded as previous. */}
            <Suspense fallback={<LinearIndeterminate />}>
              {" "}
              <ErrorBoundary FallbackComponent={ErrorFallback}>
                <Routes>
                  {/* RealHomePage doesnt need to be lazy loaded, as users may land on this page */}
                  <Route exact path="/" element={<RealHomePage />} />
                  <Route path="/ContactPage" element={<ContactPage />}></Route>
                  <Route
                    path="/TermsAndConditions"
                    element={<TermsAndConditions />}
                  ></Route>
                  <Route path="/About" element={<About />} />
                  <Route path="/site/:id" element={<BusinessMicrosite />} />
                  <Route
                    path="/site-preview/:id"
                    element={
                      <PrivateRoutes>
                        <BusinessMicrosite previewMode />
                      </PrivateRoutes>
                    }
                  />
                  {/* <Route path="/UsageInfo" element={<UsageInfo />} /> */}
                  <Route path="/Pricing" element={<Pricing />} />
                  <Route path="/Signup" element={<Signup />} />
                  <Route path="/Login" element={<Login />} />
                  {/* <Route
                    path="/AfterLoginPage"
                    element={
                      <PrivateRoutes>
                        <AfterLoginPage />
                      </PrivateRoutes>
                    }
                  /> */}
                  <Route
                    path="/AddBusinesses"
                    element={
                      <PrivateRoutes>
                        <AddBusinesses />
                      </PrivateRoutes>
                    }
                  />
                  <Route
                    path="/welcome"
                    element={
                      <PrivateRoutes>
                        <BusinessOnboarding />
                      </PrivateRoutes>
                    }
                  />
                  <Route
                    path="/BusinessPage"
                    element={
                      <PrivateRoutes>
                        <BusinessPage />
                      </PrivateRoutes>
                    }
                  />
                  <Route path="/Directory" element={<Directory />} />
                  <Route path="/Deals" element={<Deals />} />
                  <Route path="/Deals/:adId" element={<Deals />} />
                  <Route path="/Classifieds" element={<Deals />} />
                  <Route path="/Classifieds/:adId" element={<Deals />} />
                  <Route
                    path="/Admin/Deals"
                    element={
                      <PrivateRoutes>
                        <AdminDeals />
                      </PrivateRoutes>
                    }
                  />
                  <Route
                    path="/Admin/Classifieds"
                    element={
                      <PrivateRoutes>
                        <AdminDeals />
                      </PrivateRoutes>
                    }
                  />
                  <Route
                    path="/Admin/Businesses"
                    element={
                      <PrivateRoutes>
                        <AdminBusinesses />
                      </PrivateRoutes>
                    }
                  />
                  <Route
                    path="/directory/:businessId"
                    element={<Directory />}
                  />
                  <Route path="/blog" element={<Guides />} />
                  {/* <Route
                    path="/Directory"
                    element={
                      <PrivateRoutes>
                        <Directory />
                      </PrivateRoutes>
                    }
                  /> */}
                  <Route
                    path="/Businesses"
                    element={
                      <PrivateRoutes>
                        <Businesses />
                      </PrivateRoutes>
                    }
                  />
                  <Route
                    path="/UserProfile"
                    element={
                      <PrivateRoutes>
                        <UserProfile />
                      </PrivateRoutes>
                    }
                  />
                  <Route
                    path="/AddProduct"
                    element={
                      <PrivateRoutes>
                        <AddProduct />
                      </PrivateRoutes>
                    }
                  />
                  <Route
                    path="/ProductsAdded"
                    element={
                      <PrivateRoutes>
                        <ProductsAdded />
                      </PrivateRoutes>
                    }
                  />
                  <Route
                    path="/Analytics"
                    element={
                      <PrivateRoutes>
                        <Analytics />
                      </PrivateRoutes>
                    }
                  />
                  <Route
                    path="/Internal"
                    element={
                      <PrivateRoutes>
                        <Internal />
                      </PrivateRoutes>
                    }
                  />
                  <Route
                    path="/Payment"
                    element={
                      <PrivateRoutes>
                        <Payments />
                      </PrivateRoutes>
                    }
                  />
                  <Route
                    path="/Messages"
                    element={
                      <PrivateRoutes>
                        <Messages />
                      </PrivateRoutes>
                    }
                  />
                  <Route
                    path="/CustomerChat"
                    element={
                      <PrivateRoutes>
                        <CustomerChat />
                      </PrivateRoutes>
                    }
                  />
                  <Route path="/guides" element={<Guides />} />
                  <Route path="/guides/:blogId" element={<GuidePost />} />
                  <Route path="/submit-guide" element={<GuideSubmission />} />
                  <Route path="/blog" element={<Guides />} />
                  <Route path="/blog/:blogId" element={<GuidePost />} />
                  <Route path="/submit-blog" element={<GuideSubmission />} />
                  <Route path="/buyers-portal" element={<BuyersPortal />} />
                  <Route path="/track-order" element={<OrderTracking />} />
                  <Route
                    path="/store-orders"
                    element={
                      <PrivateRoutes>
                        <StoreOrders />
                      </PrivateRoutes>
                    }
                  />
                  <Route
                    path="/service-requests"
                    element={
                      <PrivateRoutes>
                        <ServiceRequests />
                      </PrivateRoutes>
                    }
                  />
                  <Route
                    path="/guide-analytics"
                    element={
                      <PrivateRoutes>
                        <GuideAnalytics />
                      </PrivateRoutes>
                    }
                  />
                  <Route
                    path="/blog-approval"
                    element={
                      <PrivateRoutes>
                        <GuideApproval />
                      </PrivateRoutes>
                    }
                  />
                  <Route path="/UsageInfo" element={<UsageInfo />} />
                  <Route path="/unsubscribe" element={<Unsubscribe />} />
                  <Route path="/status" element={<StatusPage />} />
                  {/* this is for pages that are not found - not in routes , etc, must be after other routes and no path is given */}{" "}
                  <Route element={<PageNotFound />} />
                </Routes>{" "}
              </ErrorBoundary>
            </Suspense>
            <CookieConsent />
          </FirebaseAuth>
        </header>
      </div>
    </Router1>
  );
}

export default App;
